import React, { useState, useEffect } from 'react';
import Tag from './Tag';


const Card = ({ element, srcsets, alt, title }) => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 900);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const image = isMobile ? element.poster_mobile : element.poster_desktop;

	return (
		<div className="stories__item flow">
			<div className="stories__img-container">{image && <img className="stories__img" src={image} srcSet={srcsets} sizes="(min-width: 900px) 50vw, 100vw" alt={alt} />}</div>

			{element.type && Object.values(element.type).length > 0 && (
				<ul className="tag-list">
					{Object.values(element.type).map((type, index) => (
						<li key={index} className="tag" dangerouslySetInnerHTML={{ __html: type }}></li>
					))}
					{Object.values(element.sector).map((sector, index) => (
						<li key={index} className="tag" dangerouslySetInnerHTML={{ __html: sector }}></li>
					))}
				</ul>
			)}

			<h3 className="h6 stories__title">
				<a href={element.permalink} aria-label={`Lees meer over ${title}`} className="stories__content-link underline-hover-only">
					{element.title}
				</a>
			</h3>
			<p className="text-small stories__text">{element.subtitle}</p>
		</div>
	);
};

export default Card;
